import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LanguageIcon from "@mui/icons-material/Language";

export default function LanguageSwitcher({ onLanguageChange }) {
	const { i18n } = useTranslation();
	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const changeLanguage = (language) => {
		i18n.changeLanguage(language);
		handleClose();
		if (onLanguageChange) {
			onLanguageChange(language);
		}
	};

	const languages = [
		{ code: "en", name: "English" },
		{ code: "zh-hk", name: "繁體中文" },
		{ code: "zh-cn", name: "简体中文" },
	];

	const currentLanguage =
		languages.find((lang) => lang.code === i18n.language) || languages[0];

	return (
		<div>
			<Button
				variant="outlined"
				startIcon={<LanguageIcon />}
				onClick={handleClick}
				size="small"
			>
				{currentLanguage.name}
			</Button>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				{languages.map((language) => (
					<MenuItem
						key={language.code}
						onClick={() => changeLanguage(language.code)}
						selected={i18n.language === language.code}
					>
						{language.name}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
}
